/*
 * @Author: jiangxd
 * @Date: 2021-06-25 10:19:56
 * @LastEditTime: 2021-08-23 13:18:30
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/library/socket/index.ts
 */

import { resolve } from 'url';
import Vue from 'vue';
import uuid4 from 'uuid';
import { globalElement } from '../utils/globalElement';
import { Functions } from '../utils/functions';
import { IPSService } from '@/services/ipsServices';
import { downloadFile } from '@/library/sheet/buffer';

export enum SOCKET_CODE {
  FAIL, // 失败
  SUCCESS, // 成功
}

export enum SOCKET_STATUS {
  N, // 未连接
  O, // 连接中
  F, // 连接失败
  S, // 成功
  W, // 等待下载
  p, // 下载完成
  R, // 重新连接
}

export default class Socket {
  api = '';

  params: any = {};

  type: 'post' | 'get' = 'get';

  $socket = Vue.prototype.$socket;
  sockets = globalElement.Vm.sockets;

  uuid = '';

  time = null;

  static download(url) {
    location.href = url;
  }

  constructor(api = '', params: Object = {}, type: 'post' | 'get' = 'get') {
    if (!api || !IPSService[api]) {
      throw new Error('socket 无请求API');
    }

    // 初始化数据
    this.api = api;
    this.params = params;
    this.type = type;
  }

  /**
   *  流程:
   *     init     : 初始化                   生成新uuid,关闭socket，在宏任务中重新初始化
   *     export   : 延迟1秒发送下载请求       判断到底是post/get，处理ajax参数，接口请求返回值无需确认，出错时抛出错误提示）
   *     listen   : 监听                    轮询接口和socket同时进行，socket有url返回时，才会resolve
   *
   */
  getDownUrl(): Promise<string> {
    const downloadState = +localStorage.getItem('downloadState');
    if (downloadState === 2) {
      return new Promise((resolve) => {
        this.downloadFile().then((res) => {
          resolve(res);
        });
      });
    }
    if (downloadState === 1) {
      this.init();
      // 延迟1秒发送请求下载请求，先让轮询和socket先订阅
      setTimeout(() => {
        this.setDownloadMsg();
      }, 1000);

      return new Promise((resolve, reject) => {
        // 轮询和socket有一个有消息，就清除掉轮询/socket，并返回
        this.poll().then((res) => {
          this.closeSockets();
          resolve(res);
        });
        this.subSocket().then((res) => {
          clearInterval(this.time);
          this.closeSockets();
          resolve(res);
        });
      });
    }
  }

  get postParams() {
    let apiParams = {};
    let exportParams = {};
    if (this.params.params) {
      this.params.params['sendToId'] = this.uuid;
      exportParams = this.params;
    } else {
      exportParams = { ...this.params, ...{ sendToId: this.uuid } };
    }

    if (this.type === 'post') {
      apiParams = {
        postParams: { ...exportParams },
      };
      return apiParams;
    }
    if (this.type === 'get') {
      apiParams = {
        queryParams: { ...exportParams },
      };
      return apiParams;
    }
  }

  downloadFile(): Promise<string> {
    return new Promise((resolve) => {
      IPSService[this.api](this.postParams).then(
        (res) => {
          if (res) {
            resolve(res);
            return downloadFile(res);
          }
        },
        (err) => {
          console.log('下载失败', err);
          globalElement.message.error('下载接口请求失败，请刷新页面重试！');
        },
      );
    });
  }

  setDownloadMsg(): void {
    IPSService[this.api](this.postParams).then(
      (res) => {
        console.log('API 请求成功');
        return;
      },
      (err) => {
        console.log('download api 请求失败', err);
        globalElement.message.error('下载接口请求失败，请刷新页面重试！');
      },
    );
  }

  init() {
    this.uuid = uuid4();
    this.closeSockets();
    setTimeout(() => {
      this.$socket.connect();
      // 发送信息给服务端
      this.$socket.emit('login', this.uuid);
    });
  }

  subSocket(): Promise<string> {
    return new Promise((resolve) => {
      this.sockets.subscribe('new_msg', (msg: string) => {
        if (msg) {
          console.log('socket message ===>', msg);
          // 兼容老的写法   success|./file/xxx.xlsx|1|https://xxx.xlsx
          if (msg.includes('success|')) {
            const msgArr = msg.split('|');
            if (msgArr[0] === 'success') {
              resolve(msgArr[3] || `${Functions.ipsHostUrlApi()}/file/download?fileUrl=${msgArr[1]}`);
            }
          } else {
            const msgInfo = JSON.parse(msg.replaceAll('&quot;', '"'));
            if (msgInfo?.code === SOCKET_CODE.SUCCESS) {
              resolve(msgInfo.url);
            }
          }
        }
      });
    });
  }

  closeSockets() {
    this.sockets.unsubscribe('new_msg'); // 取消订阅
    this.$socket.disconnect(); // 断开连接
  }

  poll(): Promise<string> {
    return new Promise((resolve) => {
      this.time = setInterval(() => {
        IPSService.getExcelDownloadUrl({
          postParams: {
            sendToId: this.uuid,
          },
        }).then(
          (res) => {
            if (res.url) {
              clearInterval(this.time);
              resolve(res.url);
            }
          },
          (err) => {
            // 报错后就停止轮询
            console.log(err);
            clearInterval(this.time);
          },
        );
      }, 3000);
    });
  }
}
